import React, { FC } from 'react';
import styled from 'styled-components';
import { useT } from '@hooks';

const Container = styled.div`
	background: ${({ theme }) => theme.colors.bg10};
	padding: 30px 20px;

	p {
		color: ${({ theme }) => theme.colors.text21};
		font-size: 10px;
		letter-spacing: 0.3px;
		line-height: 12px;
		text-align: center;
	}

	a {
		color: ${({ theme }) => theme.colors.text14};
		text-decoration: underline;
	}
`;

export const Footer: FC = () => {
	const { T } = useT();

	return (
		<Container>
			<p dangerouslySetInnerHTML={{ __html: T('payment_text_6_19') }}></p>
		</Container>
	);
};
